/* eslint eqeqeq: "off" */
import * as React from 'react';
import { Accordion, Card, Form, Image } from 'react-bootstrap';
import { connect } from 'react-redux';
import { updateClaimPartyReducer } from '../../../actions/claimSubmitActions';
import './ClaimsThirdPartyComponent.css';
import ThirdPartyComponent from './ThirdPartyComponent';
import { ThirdPartyConfigurations } from "../../../constants/constants";
import { IThirdPartyConfig } from '../../../interfaces/ThirdParty/ThirdPartyInterface';


class ClaimsThirdPartyComponent extends React.Component<any, any>  {
    constructor(props: any) {
        super(props);

        this.state = {
            submitted: false,
            accordian0Open: false,
            email: "",
            firstname: "",
            surname: "",
            contactNumber: "",
            idNumber: "",
            vehicleReg: "",
            vehicleDescription: "",
            vehicleDamage: "",
            hasInsurance: undefined,
            optionValue: "",
            reRender: true,
            newAdded: false,
            openAccordians: ['-1'],
            stopAccordian: false,
        }

        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    async handleAdd() {
        await this.setState({ reRender: false });
        await this.props.dispatchAction(updateClaimPartyReducer(this.props.ThirdParties[0].driverType, 'add'));

        await this.setState({
            reRender: true,
            openAccordians: ['-1', (String(this.props.ThirdParties.length))]
        });
        this.handleScroll();
    }

    handleScroll() {
            if (document.getElementsByClassName('scrollclass').length) {
                document.getElementsByClassName('scrollclass')[0].scrollIntoView({ behavior: "smooth" })
            }
    }

    async handleAccordianArrow(e: any) {
        await this.setState({ reRender: false });
        var accordianList = this.state.openAccordians.length ? this.state.openAccordians : [];
        var stopAccordian = false;
        if (this.props.ErrorList && this.props.ErrorList.length > 0) {
            stopAccordian = true;
        }
        if (accordianList.find(x => x == e)) {
            accordianList = ['-1'];
        }
        else {
            accordianList = ['-1', String(e)]
        }
        this.setState({
            openAccordians: accordianList,
            reRender: true,
            stopAccordian: stopAccordian,
        });
        this.handleScroll();
    }

    public render() {
        let openAccordians = this.state.openAccordians;
        if (this.props.ErrorList && this.props.ErrorList.length > 0 && !this.state.stopAccordian) {
            openAccordians = openAccordians ?? [];
            openAccordians.push(this.props.ErrorList[0].id);
        }
        let claimParties = <div></div>;
        let removeFlag = this.props.ThirdParties && this.props.ThirdParties.length > 1 ? true : false;
        let partyAccordian = <div></div>;
        let fieldConfig = ThirdPartyConfigurations[0] as IThirdPartyConfig;
        if (this.props.ThirdParties && this.props.ThirdParties.length > 0) {
            let counter = 1;
            let openAccordian = false;
            let nextIsOpen = false;
            let duplicateStr = "";
            let invalidStr = "";
            fieldConfig = ThirdPartyConfigurations.find(x => x.thirdPartyConfigType == this.props.ThirdParties[0].driverType) as IThirdPartyConfig;
            claimParties = this.props.ThirdParties.map((item) => {
                counter++;
                openAccordian = false;
                duplicateStr = "";
                invalidStr = "";
                if (openAccordians) {
                    openAccordian = openAccordians.find(x => x == (counter - 1)) ? true : false;
                    nextIsOpen = openAccordians.find(x => x == (counter)) ? true : false;
                    if (this.props.ErrorList.find(x => x.id == (counter - 1) && x.duplicate != '')) {
                        duplicateStr = this.props.ErrorList.find(x => x.id == (counter - 1)).duplicate;
                    }
                    if (this.props.ErrorList.find(x => x.id == (counter - 1) && x.invalid != '')) {
                        invalidStr = this.props.ErrorList.find(x => x.id == (counter - 1)).invalid;
                    }
                }
                return <div className={nextIsOpen ? "scrollclass" : ""}>
                    <ThirdPartyComponent ThirdParty={item}
                        ShowRemove={removeFlag}
                        PartyCount={String(counter - 1)}
                        HandleAccordian={(e) => this.handleAccordianArrow(e)}
                        AccordianOpen={openAccordian}
                        FieldConfig={fieldConfig}
                        Submitted={this.props.Submitted}
                        Duplicates={duplicateStr}
                        Invalid={invalidStr}
                    />
                </div>
            });

            partyAccordian =
                <div className="row noma mt-15px">
                    <div className={"col-12 nopa new-ssp-thirdparty-block" + (removeFlag ? " col-lg col-md" : "")} id="Other">
                        <Accordion activeKey={this.state.openAccordians}>
                            <Card className="mb-3">
                                {claimParties}
                            </Card >
                        </Accordion >
                    </div >
                </div >
        }
        return (
            <>
                <div>
                    {this.state.reRender && partyAccordian}
                    <hr className="addParty-hr" />
                    <div className="row noma text-lg-right">
                        <div className="col-12 nopa">
                            <p className="font-weight-normal line-height-normal mb-0px"><img title="Add another party" alt="" src="./Images/Circle-plus.svg" className="mr-10px cursor-pointer" onClick={this.handleAdd} /> Add {fieldConfig.addText}</p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimsThirdPartyComponent);